import * as XLSX from 'xlsx/xlsx';

const downloadxls = (
  data: Record<string, unknown>[],
  fileName = 'export-from-mizfa-tools'
): void => {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
};

export default downloadxls;
